export enum DataSourceEntityType {
  Source = 'Source',
  StreamOutput = 'StreamOutput',
  Transform = 'Transform',
  Unknown = 'Unknown',
}
